import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { closeModal } from 'src/actions/modals';

import Modal from 'react-modal';
import ModalContainer from '../modalContainer';
import { PrimaryButton } from 'src/components/button';
import { modalStyles } from '../styles';
import { Wrapper, H1, Action } from './style';
import { Avatar } from 'src/components/avatar';

const DATA_TEST_PRE = 'join-group-reminder-modal-';
const JoinGroupReminderModal = props => {
  const { isOpen, dispatch } = props;
  const styles = modalStyles(480);

  const close = () => dispatch(closeModal());

  return (
    <Modal
      /* TODO(@mxstbr): Fix this */
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      style={styles}
      closeTimeoutMS={330}
    >
      <ModalContainer closeModal={close}>
        <Wrapper>
          <Avatar source="/img/joinGroupReminder.png" size={150} />
          <H1>Please join a group first before creating a post/event</H1>
          <Action>
            <PrimaryButton
              onClick={close}
              data-testid={`${DATA_TEST_PRE}-confirm`}
            >
              GOT IT
            </PrimaryButton>
          </Action>
        </Wrapper>
      </ModalContainer>
    </Modal>
  );
};

const map = state => ({
  isOpen: state.modals.isOpen,
});

export default compose(
  // $FlowIssue
  connect(map),
  withRouter
)(JoinGroupReminderModal);
